// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import { Client } from '@utils/mailClient';

import { DrumkitPlatform } from 'contexts/sidebarStateContext';

export const DraftReplyMode = {
  Reply: 'reply',
  ReplyAll: 'replyAll',
} as const;

export type DraftReplyMode =
  (typeof DraftReplyMode)[keyof typeof DraftReplyMode];

export interface DraftReplyProps {
  threadItemId: string;
  draftBody: string;
  replyMode?: DraftReplyMode;
  // When set, applied to the Outlook draft / Graph reply.
  // Prefer the full intended lists shown in the draft UI — empty arrays clear
  // existing compose recipients.
  to?: string[];
  cc?: string[];
  bcc?: string[];
}

export interface MailClientInterface {
  draftReply({
    threadItemId,
    draftBody,
    replyMode,
    to,
    cc,
    bcc,
  }: DraftReplyProps): Promise<void>;
  sendReply({
    threadItemId,
    draftBody,
    replyMode,
    to,
    cc,
    bcc,
  }: DraftReplyProps): Promise<void>;
}

// Platforms whose host app ships a mail client that can draft replies.
export function supportsMailClient(platform: DrumkitPlatform): boolean {
  return (
    platform === DrumkitPlatform.Outlook || platform === DrumkitPlatform.Front
  );
}

// The Front plugin SDK can open a draft in the rep's composer but cannot send.
export function supportsMailClientSend(platform: DrumkitPlatform): boolean {
  return platform === DrumkitPlatform.Outlook;
}

export function createMailClientInstance(
  client: DrumkitPlatform
): MailClientInterface {
  if (!supportsMailClient(client)) {
    throw new Error('Invalid mail client type: ' + client);
  }

  return new Client();
}
